import React from 'react'
import PropTypes from 'prop-types'
import { FadeInUpAnimationWrapper } from 'styles/animation'
import trackGTM from 'utils/trackGTM'
import GA4 from 'utils/GA4'

import PartnersCardLink from './PartnersCardLink'
import { Body, Brow, Content, Image, Wrapper } from './PartnersCard.style'

const PartnersCard = ({
  body,
  count,
  eyebrow,
  image,
  url,
  altText,
  enableImageFadeIn,
  headline,
  villageSlug,
}) => {
  // Only display the content section if an eyebrow or body has been specified.
  const shouldDisplayContent = !!eyebrow || !!body

  return (
    <Wrapper
      count={count}
      onClick={() => {
        GA4('grid_partner_cards_click', {
          headline: eyebrow,
          component_headline: headline,
          village_name: villageSlug,
        })
      }}>
      <PartnersCardLink url={url}>
        <FadeInUpAnimationWrapper enabled={enableImageFadeIn}>
          {!!image && (
            <Image
              image={image?.landscape?.gatsbyImageData}
              alt={altText}
              objectFit="contain"
            />
          )}
        </FadeInUpAnimationWrapper>
        {shouldDisplayContent && (
          <Content
            onClick={() => {
              trackGTM(
                'cta interaction',
                'cta interaction',
                'in page cta',
                eyebrow
              )
            }}>
            {!!eyebrow && <Brow>{eyebrow}</Brow>}
            {!!body && <Body>{body}</Body>}
          </Content>
        )}
      </PartnersCardLink>
    </Wrapper>
  )
}

PartnersCard.propTypes = {
  altText: PropTypes.string,
  body: PropTypes.string,
  count: PropTypes.number,
  eyebrow: PropTypes.string,
  image: PropTypes.shape({
    portrait: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
      }).isRequired,
    }),
    landscape: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
      }).isRequired,
    }),
  }),
  url: PropTypes.string,
  enableImageFadeIn: PropTypes.bool,
  headline: PropTypes.string,
  villageSlug: PropTypes.string,
}

PartnersCard.defaultProps = {
  altText: '',
  body: undefined,
  count: 0,
  eyebrow: undefined,
  image: null,
  url: '',
  enableImageFadeIn: false,
  headline: '',
  villageSlug: '',
}

export default PartnersCard
